import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { AddToTrolley, AddToWishlist, StoreSelector } from '@sainsburys-tech/bolt'

import {
  alternativesReducer,
  avAlternativesReducer,
  availabilityReducer,
  cmsReducer,
  productStoreReducer,
  resourceReducer,
  storeLocatorReducer,
  bazaarVoiceQuestionAnswerReducer,
  bazaarVoiceReviewReducer,
  featuredProductsReducer,
  calculateBasketPriceReducer,
  specialOffersCreatorReducer,
  shopCollectionReducer,
  essentialExtrasReducer
} from '.'

const rootReducer = history => {
  const router = history ? connectRouter(history) : {}
  return combineReducers({
    router,
    ...AddToTrolley.reducers,
    ...AddToWishlist.reducers,
    ...StoreSelector.reducers,
    availability: availabilityReducer,
    resource: resourceReducer,
    cms: cmsReducer,
    alternatives: alternativesReducer,
    avAlternatives: avAlternativesReducer,
    productStore: productStoreReducer,
    storeLocator: storeLocatorReducer,
    bazaarVoiceQuestionAnswer: bazaarVoiceQuestionAnswerReducer,
    bazaarVoiceReview: bazaarVoiceReviewReducer,
    featuredProducts: featuredProductsReducer,
    specialOfferPrice: calculateBasketPriceReducer,
    specialOffersCreator: specialOffersCreatorReducer,
    shopCollection: shopCollectionReducer,
    essentialExtras: essentialExtrasReducer
  })
}

export default rootReducer
